'use client';

import { ArrowUpRight } from 'lucide-react';
import type { ReactNode } from 'react';
import { cn } from '~/lib/utils';

type TitleLinkProps = {
  title: string;
  icon?: React.ElementType;
  link: {
    text: ReactNode;
    href: string;
  };
  description?: string;
  isInternal?: boolean;
};

export default function TitleLink({
  title,
  icon: Icon,
  link,
  description,
  isInternal = false,
}: TitleLinkProps) {
  return (
    <div>
      <div className="text-muted-foreground text-sm font-medium">{title}</div>
      <a
        href={link.href}
        className="text-foreground group relative mt-2 flex items-center text-sm font-medium no-underline"
        target={isInternal ? undefined : '_blank'}
        rel={isInternal ? undefined : 'noopener noreferrer'}
      >
        {Icon ? <Icon className="mr-1 size-4 shrink-0" height={16} strokeWidth={2} /> : null}
        <span className="relative">
          {link.text}
          <span className="bg-foreground absolute bottom-0 left-0 h-px w-0 opacity-70 transition-all duration-300 ease-out group-hover:w-full" />
        </span>
        {!isInternal ? (
          <ArrowUpRight className="ml-1 size-3.5 shrink-0 -translate-x-1 opacity-0 transition-all duration-200 group-hover:translate-x-0 group-hover:opacity-100" />
        ) : null}
      </a>
      {description ? (
        <div className="text-muted-foreground mt-2 text-sm font-medium">{description}</div>
      ) : null}
    </div>
  );
}
